import React from 'react';
import { useParams } from 'react-router-dom';
import ChatWidget from '../components/ChatWidget';

const ChatWidgetPage = () => {
  const { streamId } = useParams();

  if (!streamId) {
    return (
      <div style={{ background: 'black', height: '100vh', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>No stream ID provided</p>
      </div>
    );
  }

  return <ChatWidget streamId={streamId} />;
};

export default ChatWidgetPage;
